import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { StreamingService } from 'src/app/services/streaming/streaming.service';
import { StreamingDomainIframeService } from 'src/app/services/streamingDomainIframe/streamingDomainIframe.service';
import { StreamingStadisticsService } from 'src/app/services/streamingStadistics/streamingStadistics.service';

@Component({
  selector: 'app-iframe-streaming',
  templateUrl: './iframe-streaming.component.html',
  styleUrls: ['./iframe-streaming.component.css']
})
export class IframeStreamingComponent implements OnInit{
  token: string;
  showCamera = true;
  streaming = ''; // No mostrar "Validando..." - todo en segundo plano
  imagePreview = "";
  showLive = false;
  streamingFile = "";
  streamingUrl = "";
  id = "";
  streamingKey = "";
  successValidate = 0;
  url:string;
  enterpriseId = 0;
  idCamera = 0;
  isAllowedToShow = true; // Variable de control para permitir mostrar el video
  videoLoaded = false; // Flag para saber si el video ya se cargó
  validationComplete = false; // Flag para saber si la validación ya terminó
  validationResult = true; // Resultado de la validación (true = permitido, false = denegado)

  constructor(
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private streamingStadisticsService: StreamingStadisticsService,
    private streamingService: StreamingService,
    private streamingDomainIframeService: StreamingDomainIframeService) {
    // NO mostrar spinner inmediatamente - validar en segundo plano
    this.route.params.subscribe(params => {
      this.token = params['token'];
    });
  }

  /**
   * Función para detectar la URL de origen compatible con todos los navegadores y dispositivos
   * Funciona en: Chrome, Firefox, Safari, Edge, Opera, iOS Safari, Android Chrome, etc.
   */
  private getOriginUrl(): string {
    let originUrl = '';
    
    try {
      // Método 1: Si está en un iframe, usar document.referrer (funciona en la mayoría de navegadores)
      if (window.self !== window.top) {
        originUrl = document.referrer;
      }
      
      // Método 2: Si document.referrer está vacío, intentar con ancestorOrigins (Safari, Chrome)
      if (!originUrl && window.location.ancestorOrigins && window.location.ancestorOrigins.length > 0) {
        originUrl = window.location.ancestorOrigins[window.location.ancestorOrigins.length - 1];
      }
      
      // Método 3: Si aún no hay URL, intentar obtener del parent (algunos navegadores móviles)
      if (!originUrl && window.parent && window.parent.location && window.parent.location.href) {
        try {
          originUrl = window.parent.location.href;
        } catch (e) {
          // Cross-origin error esperado, ignorar
        }
      }
      
      // Método 4: Si no está en iframe, usar la URL actual
      if (!originUrl && window.self === window.top) {
        originUrl = window.location.href;
      }
      
      // Método 5: Fallback - intentar obtener desde el header HTTP (si está disponible)
      if (!originUrl) {
        // Intentar obtener desde meta tag si existe
        const metaOrigin = document.querySelector('meta[name="referrer"]');
        if (metaOrigin) {
          originUrl = (metaOrigin as HTMLMetaElement).content;
        }
      }
      
      // Limpiar la URL para obtener solo el origen (protocolo + dominio)
      if (originUrl) {
        try {
          const urlObj = new URL(originUrl);
          originUrl = urlObj.origin; // Obtener solo protocolo + dominio + puerto
        } catch (e) {
          // Si falla el parsing, usar la URL completa
        }
      }
    } catch (error) {
      console.warn('Error al detectar URL de origen:', error);
      // Fallback final: usar la URL actual
      originUrl = window.location.href;
    }
    
    return originUrl || '';
  }

  /**
   * Función que decide si mostrar el video basándose en el estado de ambas operaciones
   * Muestra el video tan pronto como se carga, y lo oculta si la validación falla
   */
  private checkAndShowVideo(){
    // Si el video ya se cargó, mostrarlo inmediatamente (no esperar validación)
    if(this.videoLoaded && this.isAllowedToShow){
      this.showCamera = false;
      this.successValidate = 1;
    }
    
    // Si la validación terminó y falló, ocultar el video (aunque ya se haya mostrado)
    if(this.validationComplete && !this.validationResult){
      this.showCamera = true;
      this.streaming = 'NO TIENE PERMISOS PARA VER LA TRANSMISIÓN';
      this.isAllowedToShow = false;
      this.successValidate = 0;
      // Limpiar datos del video
      this.streamingUrl = "";
      this.id = "";
    }
  }

  ngOnInit(){
    // Obtener URL de origen compatible con todos los dispositivos y navegadores
    this.url = this.getOriginUrl();
    
    // Inicializar flags - permitir mostrar video por defecto
    this.videoLoaded = false;
    this.validationComplete = false;
    this.validationResult = true; // Por defecto permitir mostrar
    this.isAllowedToShow = true; // Permitir mostrar hasta que se valide
    
    // Iniciar ambas operaciones en paralelo
    // El video se mostrará tan pronto como se cargue (sin esperar validación)
    this.showIframe();
    
    // Validar en segundo plano - si falla, ocultar el video después
    if(this.url && this.url !== ""){
      this.streamingDomainIframeService.validateDomain(this.url).subscribe( _ => {
        if(_.error == null && _.validate){
          // Validación exitosa - mantener el video visible
          this.validationResult = true;
          this.isAllowedToShow = true;
          this.successValidate = 1;
        }else{
          // Validación fallida - OCULTAR el video
          this.validationResult = false;
          this.isAllowedToShow = false;
          this.successValidate = 0;
          this.spinner.show();
          this.streaming = 'NO TIENE PERMISOS PARA VER LA TRANSMISIÓN';
          setTimeout(() => {
            this.spinner.hide();
          }, 2000);
        }
        // Marcar validación como completa
        this.validationComplete = true;
        // Verificar si se debe ocultar el video
        this.checkAndShowVideo();
        this.saveStadistics();
      }, error => {
        // Error en la validación - OCULTAR el video
        this.validationResult = false;
        this.isAllowedToShow = false;
        this.validationComplete = true;
        this.successValidate = 0;
        this.spinner.show();
        this.streaming = 'NO TIENE PERMISOS PARA VER LA TRANSMISIÓN';
        setTimeout(() => {
          this.spinner.hide();
        }, 2000);
        // Verificar si se debe ocultar el video
        this.checkAndShowVideo();
        this.saveStadistics();
      });
    }else{
      // Si no hay URL para validar, considerar validación como exitosa
      this.validationComplete = true;
      this.validationResult = true;
      this.isAllowedToShow = true;
      this.checkAndShowVideo();
    }
  }

  @HostListener('contextmenu', ['$event'])
  onRightClick(event: { preventDefault: () => void; }) {
    event.preventDefault();
  }


  saveStadistics(){
    var data = {
      successValidate: this.successValidate,
      originDomain: this.url,
      idCamera: this.idCamera,
      idEnterprise: this.enterpriseId,
      origin: 'iframe'
    }
    this.streamingStadisticsService.createStadistics(data).subscribe(_ => {});
  }

  showIframe(){

    this.streamingService.getCameraIframeToken(this.token).subscribe( _ => {
      if(_.camera != null){
        this.streaming = '';
        //this.streamingFile = _.camera.streamingFile;
        if(_.camera.streamingImage == null && !_.camera.streamingImage){
          this.imagePreview =  "../../../../../assets/images/logo-claro.png";
        }else{
          this.imagePreview = _.camera.streamingImage;
        }
        this.streamingUrl = _.camera.streamingUrl;
        this.enterpriseId = _.camera.enterpriseId;
        //this.streamingKey = _.camera.streamingKey;
        this.id = "video"+_.camera.cameraId.toString();
        this.idCamera = _.camera.cameraId;
        
        // Marcar video como cargado
        this.videoLoaded = true;
        
        // Verificar si se puede mostrar el video (depende de la validación)
        this.checkAndShowVideo();
      }else{
        this.streaming = 'LA TRANSMISIÓN HA SIDO DADA DE BAJA';
        this.videoLoaded = true; // Marcar como cargado aunque no haya cámara
        this.checkAndShowVideo();
      }
      this.spinner.hide();
      this.saveStadistics();
    });
  }

  showStreaming(){
    this.showLive = true;
  }
}
